import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ChevronUpIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="m12.001 8.121-8.94 8.94L2.002 16l10-10 10 10-1.06 1.06L12 8.122Z" />
  </IconWrapper>
)

export default ChevronUpIconMedium
